/**
 * Retourne les erreurs des champs.
 * @param {object} param0
 * @param {any} param0.data
 * @returns {any}
 */
export default function parseFieldErrorsV2({ data }) {
  return data?.errors?.[0]?.meta?.fields ?? {};
}
